import React, { useMemo, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import TextField from '../../Form/TextField/TextField';
import CalendarInput from '../../Form/CalendarInput/CalendarInput';
import CustomDayPicker from '../../CustomDayPicker/CustomDayPicker';
import DeleteDialog from '../DeleteDialog';
import { BinOutlinedIcon } from '../../Icons';

import { useWindowSize } from '../../../../utils/hooks';
import { deleteModalConfigs, maxSymbolQTY } from '../../../../utils/constants';
import { generalEnums } from '../../../../utils/enums';

import classes from '../scss/addEditFormModal.module.scss';

import('react-datepicker/dist/react-datepicker.css');
import('../../../../scss/datepicker.css');

function TrainingsForm(props) {
  const { addEditForm, deleteHandler } = props;

  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const size = useWindowSize();
  const deleteModalConfig = useMemo(() => deleteModalConfigs(t), [t]);

  return (
    <div className={`${classes.formContainer} w-full`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        {/* Type Field */}
        <TextField
          placeholder="Type"
          label="Type"
          labelClass="text-sm"
          inputClass="!text-sm px-3 py-4 text-black !font-normal !rounded-lg w-full"
          value={addEditForm.values?.type}
          onChange={(e) => {
            addEditForm.setFieldTouched('type', true, true);
            addEditForm.setFieldValue('type', e.target.value, true);
          }}
          error={addEditForm.touched?.type && Boolean(addEditForm.errors.type)}
          errorText={addEditForm.touched?.type && addEditForm.errors.type}
        />

        {/* Certificate ID */}
        <TextField
          placeholder="Certificate ID"
          label="Certificate ID"
          labelClass="text-sm"
          inputClass="!text-sm px-3 py-4 text-black !font-normal !rounded-lg"
          value={addEditForm.values?.certId}
          onChange={(e) => {
            addEditForm.setFieldTouched('certId', true, true);
            addEditForm.setFieldValue('certId', e.target.value, true);
          }}
          error={addEditForm.touched?.certId && Boolean(addEditForm.errors.certId)}
          errorText={addEditForm.touched?.certId && addEditForm.errors.certId}
        />

        {/* Valid Date */}
        <div className="flex flex-col gap-2">
          <label className="text-black text-sm">{t('common.forms.validto') || 'Valid To'}</label>
          <CustomDayPicker
            testId='validDate'
            date={addEditForm.values?.valid || dayjs()}
            changeHandler={(newValue) =>
              addEditForm.setFieldValue('valid', newValue, true)
            }
            dayFormat={generalEnums.DATEWITHSTANDARD}
            sx={{
              width: '100%',
              fieldset: { legend: { width: 'unset' } },
              input: { fontSize: '14px' },
            }}
            rerender
            clearHandler={() => addEditForm.setFieldValue('valid', null, true)}
          />
        </div>
      </div>

      {/* Delete Button */}
      {!!deleteHandler && (
        <div
          className="mt-4 text-red-600 flex items-center gap-1 cursor-pointer text-sm font-medium"
          role="presentation"
          onClick={() => setOpen(true)}
        >
          <span>{t('common.general.delete')}</span>
          <BinOutlinedIcon />
        </div>
      )}

      <DeleteDialog
        open={open}
        closeHandler={() => setOpen(false)}
        confirmHandler={deleteHandler}
        config={deleteModalConfig.trainings}
      />
    </div>
  );
}

export default TrainingsForm;
